import { render } from "./withdraw.vue?vue&type=template&id=bb0bbfb0&scoped=true"
import script from "./withdraw.vue?vue&type=script&lang=js"
export * from "./withdraw.vue?vue&type=script&lang=js"

import "./withdraw.vue?vue&type=style&index=0&id=bb0bbfb0&lang=scss&scoped=true"
import "./withdraw.vue?vue&type=style&index=1&id=bb0bbfb0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0bbfb0"]])

export default __exports__